import { render, staticRenderFns } from "./ReportHeader.vue?vue&type=template&id=01f84412&scoped=true&"
import script from "./ReportHeader.vue?vue&type=script&lang=js&"
export * from "./ReportHeader.vue?vue&type=script&lang=js&"
import style0 from "./ReportHeader.vue?vue&type=style&index=0&id=01f84412&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f84412",
  null
  
)

export default component.exports